import React, { Component } from 'react'
import { Card, Form, Input } from 'antd'
import { compose } from 'recompose'
import { get, isEmpty } from 'lodash'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import StatementForm from '../../StatementForm'

const { TextArea } = Input

class ReceiptForm extends Component {
  render() {
    const { getFieldDecorator } = this.props.form
    const { transaction, StatementSelectCmp, onChangeStatement, statement } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18, offset: 1 },
      },
    }
    return (
      <Form layout={'horizontal'}>
        <Form.Item {...formItemLayout} label={'Statement'}>
          {getFieldDecorator('company._id', {
            initialValue: get(transaction, 'company._id'),
            rules: [{ required: true, message: 'Please Select a Statement!' }],
          })(
            <StatementSelectCmp
              keyAtr={'_id'}
              valueAtr={'no'}
              placeholder={'Bank Statement'}
              onChange={onChangeStatement}
            />
          )}
        </Form.Item>
        <Card title={'Statement Details'} disabled={true}>
          {!isEmpty(statement) && <StatementForm statement={statement} lodaing={false} />}
        </Card>
      </Form>
    )
  }
}

ReceiptForm.propTypes = {}
ReceiptForm.defaultProps = { transaction: {}, type: 'new' }

export default compose(Form.create(), withLoadingSection)(ReceiptForm)
